import { env } from "./env";

const GlobalVariable = {
    wcClient: env.REACT_APP_WcCLIENT,
    //  W2: "W2",
    ReliableSoftURL: env.REACT_APP_BASE_URL
};
export default GlobalVariable;